import { Pipe, PipeTransform } from '@angular/core';
import { capitalize } from '../../helpers';

@Pipe({
  name: 'mzicCapitalize',
  standalone: true,
})
export class MzicCapitalizePipe implements PipeTransform {
  transform(value: string): string {
    return capitalize(value);
  }
}
